<template>
  <van-nav-bar
      :title="title"
      :border="false"
      placeholder
      @click-left="onClickBack"
      @click-right="onClickShopCart">
    <template #left>
      <i class="iconfont icon-fanhui"></i>
    </template>
    <template #right v-if="showShopCart">
      <i class="iconfont icon-gouwuche">
        <van-badge :content="cartNum"/>
      </i>
    </template>
  </van-nav-bar>
</template>

<script>
import {defineComponent, computed} from "vue";
import {useRoute, useRouter} from "vue-router";
import store from '@/store';

export default defineComponent({
  name: "NavBar",
  props: {
    title: {
      type: String,
      default: ''
    },
    showShopCart: {
      type: Boolean,
      default: false
    },
  },
  setup(props) {
    const route = useRoute();
    const router = useRouter();
    const title = computed(() => {
      return props.title;
    });
    const showShopCart = computed(() => {
      return props.showShopCart;
    });
    // 购物车数量
    const cartNum = computed(() => {
        return store.state.reader.cartNum;
    });
    const onClickBack = () => {
      if (route.name === "SearchResults") {
          router.push({path: '/index'});
      } else if(route.name === "ReceivingAddress"){
          router.push({path: '/personalCenter'});
      }else if(route.name === "ToBeConfirmed"){
          router.push({path: '/personalCenter'});
      } else {
          router.go(-1);
      }
    };
    const onClickShopCart = () => {
			router.push({path: '/shopCart'});
    };
    return {
      title,
      showShopCart,
      onClickBack,
      onClickShopCart,
      route,
      router,
      cartNum
    }
  },
});
</script>

<style scoped lang="less">
@import "../../assets/css/navbar.less";
</style>
